export const DateRangeActionTypes = {
  GET_DATE_RANGE: '[DealersInsights DateRange] FETCH BEGIN',
  FETCH_DATE_RANGE_SUCCESS: '[DealersInsights DateRange] FETCH SUCCESS',
  FETCH_DATE_RANGE_ERROR: '[DealersInsights DateRange] FETCH ERROR',
  FETCH_DATE_RANGE_LOADING: '[DealersInsights DateRange] FETCH LOADING',
  FETCH_DATE_RANGE_CANCELLED: '[DealersInsights DateRange] FETCH CANCELLED',
  RESET_DATE_RANGE: '[DealersInsights AuthStatus] RESET DATE RANGE',
};
